const log = {
    invalid_type: 'Тип журнала недействительный.',
};
export default Object.freeze(log);
